/* eslint-disable react/prop-types */
import { Box, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { ChangeLogPopover, TimeEntryModal } from '../../../components/pop-over';
import { isAdmin } from '../../../utils/share';

export default function TotalTime({ date, totalTime, runningTask, employeeList, projectList, fetchTimeline }) {
  const todayDate = dayjs(date).format('ddd, MMMM D, YYYY');
  const isRunning =
    runningTask && new Date(runningTask?.TimeTracker?.[0]?.startTime).toDateString() === new Date(date).toDateString();

  let runningMilli = 0;
  if (isRunning) runningMilli = new Date() - new Date(runningTask?.TimeTracker?.[0]?.startTime);
  const totalHour = Math.floor((totalTime + runningMilli) / (1000 * 60 * 60));
  const totalMinute = Math.floor(((totalTime + runningMilli) % (1000 * 60 * 60)) / (1000 * 60));

  return (
    <>
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" gutterBottom>
            Total time
          </Typography>
          <Link to="../report" style={{ textDecoration: 'none' }}>
            {' '}
            View report{' '}
          </Link>
        </Box>
        <Box sx={{ display: 'flex', textAlign: 'center', flexDirection: 'column', alignItems: 'center', mt: 3 }}>
          <Typography variant="p" gutterBottom>
            {todayDate}
          </Typography>
          <Typography variant="h3" gutterBottom>
            {`${totalHour}h ${totalMinute}m`}
          </Typography>
        </Box>
        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          {isAdmin() && (
            <TimeEntryModal
              action="create"
              date={date}
              employeeList={employeeList}
              projectList={projectList}
              fetchTimeline={fetchTimeline}
            />
          )}
          <ChangeLogPopover />
        </Box>
      </Paper>
    </>
  );
}
